<template>
  <div class="checkout-header">
    <a :href="clientModel.startPageUrl" :aria-label="tStatic('goToStartPage')" class="checkout-header__logo">
      <oie-use-svg svg="olsson-logo" class="checkout-header__logo-svg"></oie-use-svg>
    </a>

    <div
      v-if="clientModel.tryggEhandelId"
      class="teh-certificate"
      data-size="45"
      data-color="black"></div>
  </div>
</template>

<script>
export default {
  props: {
    logoUrl: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
.checkout-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: measure(full);
}

.checkout-header__logo {
  flex-shrink: 0;
  width: 12rem;
  margin-right: measure(half);

  @include media(small) {
    width: 15.625rem;
  }
}

.checkout-header__logo-svg {
  width: 100%;
  height: auto;
  color: color(brand-blue-2);
  margin-bottom: 20px;
}
</style>
